import { Inject, Injectable, Optional } from '@angular/core';

import { IBetslipState } from '../../../../../../base/store/state';
import { IBetslip } from '../../../../../bet-generation/models';
import { BetslipError } from '../../../../errors/betslip-error';
import { TEASER_BET_BETSLIP_VALIDATORS } from '../../../betslip-validation-injection-tokens';
import { TypeContextGeneratorService } from '../../../generators/context/type-context-generator.service';
import { ITeaserBetBetslipValidator } from '../../../validators/type/validators';

@Injectable()
export class BetslipTeaserBetValidationComposerService {
    constructor(
        private typeContextGenerator: TypeContextGeneratorService,
        @Optional() @Inject(TEASER_BET_BETSLIP_VALIDATORS) private validators?: ITeaserBetBetslipValidator<BetslipError>[],
    ) {}

    validate(betslip: IBetslip, state: IBetslipState): BetslipError[] {
        const context = this.typeContextGenerator.generateTeaserBetContext(state);

        return this.validators?.flatMap((v) => Array.from(v.validate(betslip, context))) ?? [];
    }
}
